import { useState, useCallback, useEffect } from 'react';

/**
 * Shared dark-mode state.
 *
 * Extracted from Header so both MegaNav and MobileDrawer can toggle without
 * duplicating the DOM + localStorage dance. The class on <html> is the source
 * of truth — React state just tracks it so the icon can flip.
 */
export function useDarkMode() {
  // Start with the same value used by the server-rendered navigation, then
  // synchronize with the class that the inline theme script applied.
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    setIsDark(document.documentElement.classList.contains('dark'));
  }, []);

  const toggle = useCallback(() => {
    setIsDark(prev => {
      const next = !prev;
      if (next) {
        document.documentElement.classList.add('dark');
        try { localStorage.setItem('npw_theme', 'dark'); } catch { /* blocked */ }
      } else {
        document.documentElement.classList.remove('dark');
        try { localStorage.setItem('npw_theme', 'light'); } catch { /* blocked */ }
      }
      return next;
    });
  }, []);

  return { isDark, toggle } as const;
}
